<template>
  <div :class="['v-ribbon', `v-ribbon--${position}`]">
    <v-text
      bold
      :class="[
        'v-ribbon__rotate',
        'text-white',
        `bg-${color}`
      ]"
    >
      <slot></slot>
    </v-text>
  </div>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: "primary"
    },
    position: {
      type: String,
      default: "right"
    }
  }
};
</script>

<style scoped lang="scss">
@import "../../sass/component.scss";

.v-ribbon {
  position: absolute;
  top: -40px;
  right: -40px;
  width: 160px;
  height: 160px;
  pointer-events: none;
  z-index: 1;

  &--left {
    right: auto;
    left: -40px;
  }

  &__rotate {
    position: absolute;
    width: 160px;
    text-align: center;
    top: 50%;
    right: 0px;
    transform: translateY(-50%) rotate(45deg);
    padding: 3px 0;
    transform-origin: center;
    white-space: nowrap;

    .v-ribbon--left & {
      transform: translateY(-50%) rotate(-45deg);
    }
  }
}
</style>
